import { render, staticRenderFns } from "./playlists-table-block.vue?vue&type=template&id=5d04f655"
import script from "./playlists-table-block.vue?vue&type=script&setup=true&lang=js"
export * from "./playlists-table-block.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports